import React from 'react';
import ReactPlayer from 'react-player/youtube';
import { PlayCircle, Lightbulb, Heart, Target } from 'lucide-react';
export const VisionStory = () => {
  const visionPoints = [{
    icon: <Lightbulb className="w-6 h-6" data-id="element-435" data-mp="1rqf41bybi5ts" />,
    title: 'Innovation in Education',
    description: 'Reimagining how technology can support meaningful coaching relationships',
    gradient: 'from-primary-500 to-blue-600'
  }, {
    icon: <Heart className="w-6 h-6" data-id="element-436" data-mp="z3cbr1k8irbz" />,
    title: 'Human-Centered Design',
    description: 'Built with and for instructional coaches to enhance their impact',
    gradient: 'from-blue-600 to-purple-600'
  }, {
    icon: <Target className="w-6 h-6" data-id="element-437" data-mp="1d1apc4qqejqf" />,
    title: 'Measurable Impact',
    description: 'Focused on improving teacher support and student outcomes',
    gradient: 'from-pink-600 to-orange-600'
  }];
  return <section id="vision-story" className="w-full py-section-mobile md:py-section-desktop bg-white relative overflow-hidden" data-id="element-438" data-mp="2ofwk8kuxfa9q">
      <div className="container mx-auto px-6" data-id="element-439" data-mp="1oh39b4njxvzs">
        <div className="max-w-5xl mx-auto" data-id="element-440" data-mp="1jirzuv165ni3">
          {/* Header Section */}
          <div className="text-center mb-20 opacity-100" data-id="element-441" data-mp="1jgpb0ebr60ey">
            <h2 className="text-h2-mobile md:text-h2-desktop font-serif font-normal text-teal-900 mb-4 leading-tight" data-id="element-442" data-mp="1ei45q0hn8qjn">
              Our mission for high-quality coaching at scale
            </h2>
            <p className="text-xl text-teal-800 max-w-3xl mx-auto" data-id="element-443" data-mp="15jiruin49zp7">
              Our vision is to extend the reach of great instructional coaches,
              making their expertise and support more accessible to every
              teacher.
            </p>
          </div>
          {/* Vision Points */}
          {/* Video Section */}
          <div className="relative lg:max-w-[80%] lg:mx-auto" data-id="element-444" data-mp="qs0581zr56wv">
            <div className="absolute inset-0 bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl opacity-90" data-id="element-445" data-mp="mrpz8pbymgi0" />
            <div className="relative rounded-2xl overflow-hidden shadow-xl border border-gray-800" data-id="element-446" data-mp="hty65rzkwoc8">
              <ReactPlayer url="https://www.youtube.com/watch?v=JAwX1PJzNJU" width="100%" height="100%" controls playing={false} light={true} playIcon={<div className="w-20 h-20 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center border-2 border-white/20 transition-transform hover:scale-110 duration-300" data-id="element-448" data-mp="37itj4v2s27b">
                    <PlayCircle className="w-12 h-12 text-white" data-id="element-449" data-mp="vu3hrwg97y6n" />
                  </div>} className="aspect-video" data-id="element-447" data-mp="84981nr8epqm" />
            </div>
          </div>
          {/* Bottom Content */}
          <div className="mt-12 text-center lg:max-w-[80%] lg:mx-auto" data-id="element-450" data-mp="m3h96m6yg7xg">
            <div className="space-y-6 max-w-lg mx-auto" data-id="element-451" data-mp="19tuza75zbwpe">
              <p className="text-xl text-teal-800" data-id="element-452" data-mp="1elmj7yumr46k">
                In this short talk at{' '}
                <span className="font-medium" data-id="element-453" data-mp="2zc1o03ftlm8r">The AI Show at ASU+GSV 2025</span>
                , learn how Nisa aims to transform instructional coaching.
              </p>
              <p className="text-gray-600" data-id="element-454" data-mp="2ucotcwipjavm">
                From overloaded teachers to the promise of "AI as connective
                tissue," this vision grounds every decision we make.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};